import teacherEndpoints from "api/resources/teacher";
import { LOCAL_USER_TYPE } from "constants/localStorage";
import { actionByRole } from "lib/helpers";
import ResponseHandlerService from "./ResponseHandlerService";

class TeacherService {
  static instance: TeacherService;
  private respHandler = ResponseHandlerService.getInstance();

  private constructor() {}

  static getInstance(): TeacherService {
    if (!TeacherService.instance) TeacherService.instance = new TeacherService();
    return TeacherService.instance;
  }

  postTeacher = async (body: any, centerId: number) =>
    this.respHandler.handleResponse({
      promise: actionByRole(LOCAL_USER_TYPE(), {
        owner: () =>
          teacherEndpoints.postTeacherAsDirectorByCenterId(
            centerId,
            body,
          ),
        admin: () =>
          teacherEndpoints.postTeacherAsDirectorByCenterId(
            centerId,
            body,
          ),
        director: () =>
          teacherEndpoints.postTeacherAsDirectorByCenterId(
            centerId,
            body,
            ),
            teacher: () =>
          teacherEndpoints.postTeacherAsDirectorByCenterId(
            centerId,
            body,
          ),
      }),
    });

  putTeacher = async (body: any, centerId: number, teacherId: number) =>
    this.respHandler.handleResponse({
      promise: actionByRole(LOCAL_USER_TYPE(), {
        owner: () =>
          teacherEndpoints.putTeacherAsDirectorByCenterId(
            centerId,
            teacherId,
            body,
          ),
        admin: () =>
          teacherEndpoints.putTeacherAsDirectorByCenterId(
            centerId,
            teacherId,
            body,
          ),
        director: () =>
          teacherEndpoints.putTeacherAsDirectorByCenterId(
            centerId,
            teacherId,
            body,
          ),
        teacher: () =>
          teacherEndpoints.putTeacherAsDirectorByCenterId(
            centerId,
            teacherId,
            body,
          ),
      }),
    });

  updateTeacherPermissions = async (centerId: number, teacherId: number, body: any) =>
    actionByRole(LOCAL_USER_TYPE(), {
      owner: () =>
        teacherEndpoints.updateTeacherPermissions(
          centerId,
          teacherId,
          body,
        ),
      admin: () =>
        teacherEndpoints.updateTeacherPermissions(
          centerId,
          teacherId,
          body,
        ),
      director: () =>
        teacherEndpoints.updateTeacherPermissions(
          centerId,
          teacherId,
          body,
          ),
          teacher: () =>
        teacherEndpoints.updateTeacherPermissionsAsTeacher(
          centerId,
          teacherId,
          body,
        ),
    });

}

export default TeacherService;
